const STORAGE_KEY = "daat_ui_settings";

export const defaultUiSettings = {
  language: "en",
  density: "comfortable",
  datasetsPerPage: 20,
  showIntegratedTools: true,
  showDatasetGroups: true,
  animations: true,
};

const allowedPageSizes = new Set([10, 20, 40]);

export function normalizeUiSettings(settings = {}) {
  const pageSize = Number(settings.datasetsPerPage);
  return {
    language: settings.language === "zh-TW" ? "zh-TW" : "en",
    density: settings.density === "compact" ? "compact" : "comfortable",
    datasetsPerPage: allowedPageSizes.has(pageSize) ? pageSize : 20,
    showIntegratedTools: settings.showIntegratedTools !== false,
    showDatasetGroups: settings.showDatasetGroups !== false,
    animations: settings.animations !== false,
  };
}

export function loadUiSettings() {
  try {
    const storedSettings = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return normalizeUiSettings(storedSettings);
  } catch {
    return { ...defaultUiSettings };
  }
}

export function applyUiSettings(settings) {
  const normalized = normalizeUiSettings(settings);
  const root = document.documentElement;
  root.lang = normalized.language;
  root.dataset.daatLanguage = normalized.language;
  root.dataset.daatDensity = normalized.density;
  root.dataset.daatIntegratedTools = normalized.showIntegratedTools
    ? "visible"
    : "hidden";
  root.dataset.daatMotion = normalized.animations ? "enabled" : "reduced";
  return normalized;
}

export function saveUiSettings(settings) {
  const normalized = normalizeUiSettings(settings);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  applyUiSettings(normalized);
  return normalized;
}
